export default {
	terms: "Allgemeine Geschäftsbedingungen",
	and: "Und",
	actions: {
		Submit: "Absenden",
		BackToLogin: "Zurück zum Login",
		Register: "Registrieren",
		Logout: "Abmelden",
		Update: "Aktualisieren",
		Verify: "Überprüfen",
		connect: "Verbinden",
		Taptochange: "Tippen, um zu ändern"
	},
	rules: {
		isRequired: "Erforderlich",
		require: "{0} ist erforderlich",
		valid: "{0} ist kein gültiger {0}",
		cannotContainBlankStrings: "{0} darf keine leeren Zeichenfolgen enthalten"
	},
	options: {
		gender: ["Männlich", "Weiblich"]
	}
};
